/**
 * Human-readable names for capability ids, for anywhere the app shows what
 * an avatar can do - the marketplace card and an avatar's own detail view.
 *
 * Falls back to the raw id for anything not listed here, so a new capability
 * is never hidden - just plainer - until this map catches up.
 */
export const TOOL_LABEL: Record<string, string> = {
  delegate_to_brain: "memory & tasks",
  remember_preference: "learns your preferences",
  web_search: "web access",
  github_read_file: "reads GitHub files",
  github_list_issues: "lists GitHub issues",
  github_create_issue: "files GitHub issues",
};
